import { currencyList } from './currencyList';

function isBelowMinimumChargeAmount(amount, currency) {
  if (Number(amount) === 0) return false;

  if (!currency) return true;

  const { minimumStripeChargeAmount } = currencyList[currency.toLowerCase()];

  if (amount < minimumStripeChargeAmount) {
    return true;
  }

  return false;
}

function getMinimumChargeAmount(currency) {
  if (!currency) return '';

  const currencyObj = currencyList[currency.toLowerCase()];

  return currencyObj ? currencyObj.minimumStripeChargeAmount : '';
}

export { isBelowMinimumChargeAmount, getMinimumChargeAmount };
